import React from 'react';
import PropTypes from 'prop-types';
import {
  WrapperCheckbox,
  StyledCheckbox,
  StyledCheckable,
  StyledIcon
} from './style';

import Label from '../Label';

import { Check } from '../../../../assets/images/index';

const Checkbox = ({
  className,
  disabled,
  label,
  name,
  required,
  onChange,
  checked,
  id
}) => (
  <div className={className}>
    <WrapperCheckbox>
      <StyledCheckbox
        disabled={disabled}
        required={required}
        id={id}
        name={name}
        onChange={event => onChange(event.currentTarget.checked, event)}
        checked={checked}
      />
      <StyledCheckable>
        <StyledIcon color="light" svg={Check} />
      </StyledCheckable>
      <Label htmlFor={id} label={label} />
    </WrapperCheckbox>
  </div>
);

Checkbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  onChange: PropTypes.func,
  required: PropTypes.bool,
  name: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Checkbox.defaultProps = {
  required: false
};

export default Checkbox;
